import { render, staticRenderFns } from "./bloodFollowUp.vue?vue&type=template&id=f24a89ae&scoped=true"
import script from "./bloodFollowUp.vue?vue&type=script&lang=js"
export * from "./bloodFollowUp.vue?vue&type=script&lang=js"
import style0 from "./bloodFollowUp.vue?vue&type=style&index=0&id=f24a89ae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f24a89ae",
  null
  
)

export default component.exports